module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ZDialog', {
    attrs: {
      "active": _vm.show
    },
    on: {
      "update:active": function($event) {
        _vm.show = $event
      }
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })]), _vm._v(" "), _c('template', {
    slot: "default"
  }, [(_vm.message) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  }) : _vm._e()]), _vm._v(" "), _c('template', {
    slot: "actions"
  }, [_c('ZButton', {
    attrs: {
      "accent": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Отмена")]), _vm._v(" "), _c('ZButton', {
    attrs: {
      "primary": ""
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("Ок")])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62e39af7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ZModalAlert.vue
// module id = 1166
// module chunks = 0